import styled from "styled-components";

export const D1 = styled.h1`
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.5;
`;

export const D2 = styled.h2`
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.5;
`;

export const D3 = styled.h3`
  font-size: 2.18rem;
  font-weight: 600;
  line-height: 1.5;
`;

export const D4 = styled.h4`
  font-size: 1.628rem;
  font-weight: 600;
  line-height: 1.5;
`;

export const D5 = styled.h4`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.5;
`;
